import { initLazyBackgrounds } from "@/scripts/helpers/lazy.js"

export const initFooterSection = () => {
  initLazyBackgrounds();
};
